import { Tr, Td, Row, Col } from "@visa/vds"
import { APPROVED_PRODUCT_SUBTITLES, APPROVED_PRODUCT_TITLE, DASHBOARD_STAFF_APPROVED_PRODUCT_TABLE_HEADERS, DASHBOARD_USER_APPROVED_PRODUCT_TABLE_HEADERS, EXPIRATION_ALERT, getCardAlertType, getExpirationAlertIcon, renderSubtitle } from "_constants/DashboardConstants"
import { DateHelper } from "_helpers/DateHelper"
import React, { useContext, useEffect, useState } from "react"
import DashboardAccordion from "../DashboardAccordion"
import { useAuthContextUser } from "context/AuthContext"
import { DashboardUserApi, DashboardStaffApi } from "services/dashboard.service"
import MCSPagedTable from "components/MCSPagedTable"
import { trackPromise } from "react-promise-tracker"
import { GlobalAlertContext } from "context/GlobalAlertContext";
import ProductCertificationFootnotes from "./ProductCertificationFootnotes"


const PAGE_SIZE = 10

const ApprovedProductsAccordion = (props) => {
    let {
        selectedBid,
        setPageError,
    } = props

    const alertContext = useContext(GlobalAlertContext);
    const user = useAuthContextUser();

    const isExternalUser = user && user.isExternalUser;
    const approvedProductsTableHeaders = isExternalUser ? DASHBOARD_USER_APPROVED_PRODUCT_TABLE_HEADERS : DASHBOARD_STAFF_APPROVED_PRODUCT_TABLE_HEADERS
    const API = isExternalUser ? DashboardUserApi : DashboardStaffApi

    const [approvedProducts, setApprovedProducts] = useState(null);
    const [subtitle, setSubtitle] = useState(null)
    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [totalCount, setTotalCount] = useState(4);
    const [sortBy, setSortBy] = useState("Component");
    const [desc, setDesc] = useState(false);

    const setTableState = (totalCount, totalPage) => {
        setTotalCount(totalCount)
        setTotalPage(totalPage)
    }

    const setComponentState = (result) => {
        setApprovedProducts(result.data.items)
        setTableState(result.data.totalCount, Math.ceil(result.data.totalCount / PAGE_SIZE))
        setSubtitle(renderSubtitle(result.data.items, getCardAlertType(result.data.dashboardExpirationAlert), APPROVED_PRODUCT_SUBTITLES))
    }
    const onClickApprovedProductAlertIcon = (row) => {
        let data = {
            VisaCompId: row.visaCompId,
            ExpirationDate: row.expirationDate,
            ToggleOff: row.expirationAlert < EXPIRATION_ALERT.BLUE
        }

        let skipCount = (selectedPage - 1) * PAGE_SIZE;
        trackPromise(
            API.upsertApprovedProductAlert(data, selectedBid, skipCount, sortBy, desc)
                .then((result) => {
                    setComponentState(result)
                })
                .catch((error) => {
                    setPageError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    }

    const fetchData = (page, sortBy, desc) => {
        let skipCount = (page - 1) * PAGE_SIZE;
        trackPromise(
            API.getApprovedProducts(selectedBid, skipCount, sortBy, desc)
                .then((result) => {
                    setComponentState(result)
                })
                .catch((error) => {
                    setPageError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    };

    const handlePageChange = (newPage) => {
        setSelectedPage(newPage)
        fetchData(newPage, sortBy, desc);
    };

    const handleSortChange = async (sortBy = null, desc = false) => {
        fetchData(selectedPage, sortBy, desc);
    };


    useEffect(() => {
        fetchData(selectedPage, sortBy, desc);
    }, [selectedBid]);

    return (
        <Row>
            <Col>
                <DashboardAccordion id="dashboard-approved-product-accordion"
                    subtitle={subtitle}
                    title={APPROVED_PRODUCT_TITLE}
                >
                    <Row className="approved-products-table">
                        <MCSPagedTable
                            size={"compact"}
                            colHeaders={approvedProductsTableHeaders}
                            selectedPage={selectedPage}
                            setSelectedPage={handlePageChange}
                            ordered={sortBy}
                            setOrdered={setSortBy}
                            sortData={handleSortChange}
                            isDsc={desc}
                            setDsc={setDesc}
                            totalPages={totalPage}
                            pageSize={PAGE_SIZE}
                            totalCount={totalCount}
                            usePagination={true}
                            tableData={
                                approvedProducts && approvedProducts.map((row, key) => {
                                    return (
                                        <Tr className="row-vstt-even" key={key}>
                                            <Td id={"component_"+key}>{row.component}</Td>
                                            <Td id={"protocolVersion_"+key}>{row.protocolVersion}</Td>
                                            <Td id={"productName_"+key}>{row.productName}</Td>
                                            <Td id={"visaCompId_"+key}>{row.visaCompId}</Td>
                                            <Td id={"sca_"+key}>{row.sca}</Td>
                                            {/* <Td id={"daf_"+key}>{row.daf}</Td> */}
                                            <Td id={"bme_"+key}>{row.bme}</Td>
                                            <Td id={"expirationDate_"+key}>
                                                <Row>
                                                    {row.expirationAlert < EXPIRATION_ALERT.NONE
                                                        ? <span className="cursor-pointer" onClick={() => onClickApprovedProductAlertIcon(row)}>{getExpirationAlertIcon(row.expirationAlert)}</span>
                                                        : <>{getExpirationAlertIcon(row.expirationAlert)}</>}
                                                    {row.expirationDate ? DateHelper.ToFormattedDate(row.expirationDate) : ""}
                                                </Row>
                                            </Td>
                                        </Tr>
                                    )
                                })
                            }
                        />
                    </Row>
                    <Row style={totalCount < PAGE_SIZE ? { paddingTop: "20px" } : {}}>
                        <ProductCertificationFootnotes expirationDays={[60, 90, 120]} />
                    </Row>
                </DashboardAccordion>
            </Col>
        </Row>
    )
}

export default ApprovedProductsAccordion